import { render, staticRenderFns } from "./ValueEditWidget.vue?vue&type=template&id=72b5ad3f&"
import script from "./ValueEditWidget.vue?vue&type=script&lang=ts&"
export * from "./ValueEditWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports